export const getStates = country => {
  switch (country) {
    case 'NZ':
      return [
        {
          value: 'NZ',
          label: 'New Zealand',
        },
      ]
    default:
      return [
        {
          value: 'NSW',
          label: 'New South Wales',
        },
        {
          value: 'NT',
          label: 'Northern Territory',
        },
        {
          value: 'QLD',
          label: 'Queensland',
        },
        {
          value: 'SA',
          label: 'South Australia',
        },
        {
          value: 'TAS',
          label: 'Tasmania',
        },
        {
          value: 'VIC',
          label: 'Victoria',
        },
        {
          value: 'WA',
          label: 'Western Australia',
        },
        {
          value: 'ACT',
          label: 'Australian Capital Territory',
        },
      ]
  }
}



// WEBPACK FOOTER //
// ./src/utils/topography.js